export * from './lib/radio-input.component.module';

export {
  AccredibleRadioGroupOption,
  AccredibleRadioInputComponent,
} from './lib/radio-input.component';
